module.exports = __webpack_public_path__ + "img/smart-home.22edb214.jpg";